// Renderizador de texto con estilo WhatsApp: convierte **bold** en <strong>,
// preserva saltos de línea y resalta la línea divisora (━━━) como un separador sutil.
export function WaText({ text, mono = true }) {
  const lines = String(text || "").split("\n");
  return (
    <>
      {lines.map((line, i) => {
        if (/^━+$/.test(line.trim())) {
          return <div key={i} className="my-1.5 border-t border-wa-subtext/20" />;
        }
        const parts = line.split(/(\*\*[^*]+\*\*)/g).filter(Boolean);
        return (
          <div key={i} className={mono ? "font-mono" : ""} style={{ minHeight: line ? undefined : "0.6em" }}>
            {parts.map((p, j) =>
              p.startsWith("**") && p.endsWith("**") ? (
                <strong key={j} className="font-bold text-white">{p.slice(2, -2)}</strong>
              ) : (
                <span key={j}>{p}</span>
              )
            )}
          </div>
        );
      })}
    </>
  );
}

// Un teléfono/pantalla de chat WhatsApp completa: header + fondo con textura + burbujas.
export function WaChatFrame({ contactName = "ᵁᴺᴿ⚝ WARDEN", subtitle = "en línea · verificado", children, className = "" }) {
  return (
    <div className={`rounded-2xl overflow-hidden border border-white/10 shadow-2xl bg-wa-bg ${className}`} data-testid="whatsapp-chat-preview-container">
      <div className="bg-wa-surface px-4 py-3 flex items-center gap-3 border-b border-black/40">
        <div className="w-9 h-9 rounded-full bg-gradient-to-br from-gold to-crimson flex items-center justify-center text-black font-bold text-sm shrink-0">
          AW
        </div>
        <div className="flex-1 min-w-0">
          <div className="text-wa-text font-semibold text-sm truncate">{contactName}</div>
          <div className="text-wa-accent text-[11px] flex items-center gap-1">
            <span className="w-1.5 h-1.5 rounded-full bg-wa-accent inline-block" /> {subtitle}
          </div>
        </div>
      </div>
      <div className="wa-doodle-bg p-3 sm:p-4 space-y-2.5 min-h-[280px]">{children}</div>
    </div>
  );
}

// Burbuja del usuario (comando enviado) - verde, alineada a la derecha.
export function WaBubbleSent({ text, testid }) {
  return (
    <div className="flex justify-end" data-testid={testid}>
      <div className="relative bubble-tail-sent bg-wa-sent text-wa-text rounded-lg rounded-tr-none px-3 py-2 max-w-[85%] text-sm shadow-md">
        <span className="font-mono font-medium">{text}</span>
        <div className="text-right text-[10px] text-white/50 mt-1 flex items-center justify-end gap-1">
          14:32 <span className="text-sky-300">✓✓</span>
        </div>
      </div>
    </div>
  );
}

// Burbuja de respuesta del bot - gris oscuro, alineada a la izquierda.
export function WaBubbleReceived({ text, testid }) {
  return (
    <div className="flex justify-start" data-testid={testid}>
      <div className="relative bubble-tail-received bg-wa-received text-wa-text rounded-lg rounded-tl-none px-3.5 py-2.5 max-w-[92%] text-xs sm:text-sm shadow-md leading-relaxed">
        <WaText text={text} />
        <div className="text-right text-[10px] text-white/40 mt-1.5">14:32</div>
      </div>
    </div>
  );
}
